export const pluginStateMap = new WeakMap();
//# sourceMappingURL=pluginState.js.map
